<div class="accordion-card flex-column" [class.accordion-card-error]="hasVisualError">
	<div class="accordion-header" (click)="onAccordionToggle()">
		<div class="header-content">
			<h3 class="aspect-title">{{ aspect.name }}: {{ aspect.description}}</h3>
			<div class="header-controls">
				<div class="rating-label uppercase" [class]="competencyLevelDetails.class">
					<app-status-icon [aspectStatus]="aspect.status" [value]="aspect.competencyLevel"></app-status-icon>
					<span>{{competencyLevelDetails.label}}</span>
				</div>

				<button class="collapse-button">
					<span class="chevron" [class.expanded]="!isCollapsed">›</span>
				</button>
			</div>
		</div>
	</div>

	<div class="accordion-content" [@collapseAnimation]="isCollapsed ? 'collapsed' : 'expanded'">
		<div *ngIf="canEvaluateAspect; else aspectCompleted">
			<div *ngIf="showAIFeedback; else aiFeedbackNotAvailable">
				<div class="ai-analysis-block">
					<h4 class="ai-block-title">
						<mat-icon fontIcon="auto_awesome"></mat-icon>
						ASPECT ANALYSIS
					</h4>
					<p class="ai-text">
						{{ aspect.aiAnalysis || 'No analysis found.' }}
					</p>
				</div>

				<div class="ai-analysis-block">
					<h4 class="ai-block-title">
						<mat-icon fontIcon="auto_awesome"></mat-icon>
						IMPROVEMENT SUGGESTIONS
					</h4>
					<p class="ai-text">
						{{ aspect.aiSuggestions || 'No suggestions found.' }}
					</p>
				</div>
			</div>
			<ng-template #aiFeedbackNotAvailable>
				<div class="basic-card mb-4">
					<div class="flex flex-gap_10 align-center">
						<mat-icon fontIcon="auto_awesome"></mat-icon>
						<span class="ai-text text-emphasis">AI Unavailable for this aspect</span>
					</div>
				</div>
			</ng-template>

			<div class="competency-buttons">
				<app-competency-button value="Competent" (buttonToggle)="setCompetencyLevel($event)" label="Competent"
					[aspect]="aspect"></app-competency-button>
				<app-competency-button value="Approaching Competence" (buttonToggle)="setCompetencyLevel($event)"
					label="Approaching Competence" [aspect]="aspect"></app-competency-button>
				<app-competency-button value="Not Evident" (buttonToggle)="setCompetencyLevel($event)"
					label="Not Evident" [aspect]="aspect"></app-competency-button>
			</div>

			<div class="feedback-section" id="feedback" #feedback>
				<rich-text-editor [(ngModel)]="aspect.feedback" (ngModelChange)="onFeedbackChange($event)"
					(blur)="onBlur()" />
			</div>
		</div>
		<ng-template #aspectCompleted>
			<div class="basic-card">
				<div class="d-block mb-2">
					<span class="aspect-title completed-text">{{ aspectCompletedMessage.title }}</span>
				</div>
				<span class="completed-text completed-text_body">{{ aspectCompletedMessage.body }}</span>
			</div>
		</ng-template>
	</div>

	<div class="navigation-buttons-container" *ngIf="!isCollapsed">
		<span *ngIf="hasVisualError" class="error-message">{{errorMessage}}</span>
		<div class="navigation-buttons">
			<button *ngIf="!isFirst" class="nav-button uppercase" (click)="onNavigate('previous')">
				Previous
			</button>
			<button [disabled]="!canNavigateNext" class="nav-button primary uppercase" (click)="onNavigate('next')">
				{{ isLast ? 'Save' : 'Next' }}
			</button>
		</div>
	</div>
</div>